import Clock from '../../atoms/text/pilotClock';
import Gradient from '../../elements/images/gradient';
import { playerSelector } from '../../../../shared/store/slices/player.slice';
import { useAppSelector } from '../../../../shared/store/hooks';

function PilotMask() {
  const {
    pilot: displayPilot,
    nextEpisode: { display: displayNextEpisode },
  } = useAppSelector(playerSelector);

  return displayNextEpisode || displayPilot ? (
    <>
      <Gradient />
      <Clock />
    </>
  ) : null;
}

export default PilotMask;
